import React from 'react';
import { Box } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';

export const UserNetworkLogo = ({ user, network, width = '40px', height = '40px' }) => (
  <Box sx={{ position: 'relative' }}>
    <ProfilePicture name={user.fullName} imageUrl={user.avatarUrl} variant="default" width={width} height={height} />
    <Box sx={{}}>
      <ProfilePicture
        sx={{
          borderRadius: '4px',
          border: '1px solid',
          borderColor: 'border.subtle',
          position: 'absolute',
          bottom: '-6px',
          right: '-6px',
          width: '24px',
          height: '24px',
          backgroundColor: 'neutral.0',
          padding: '2px',
          boxSizing: 'border-box',
          zIndex: 1,
        }}
        name={network.name}
        imageUrl={network.logoUrl}
        variant="square"
        width="24px"
        height="24px"
      />
    </Box>
  </Box>
);

UserNetworkLogo.propTypes = {
  user: PropTypes.object.isRequired,
  network: PropTypes.object.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

UserNetworkLogo.defaultProps = {
  width: '40px',
  height: '40px',
};
